import { useSelector } from 'react-redux';
import { leerSuplantacionDelToken } from '../utils/suplantacion-del-token';

/**
 * GH#2768 — ¿esta sesión es una suplantación? `isImpersonating` (Redux) lo dice mientras la página no se recargue; el claim del token
 * lo dice también DESPUÉS de recargar, que es lo que hace `ImpersonationFlyout` al entrar (`window.location.href = '/'`).
 * Pista de interfaz: ver suplantacion-del-token.ts.
 *
 * Tolera un store sin los slices `impersonation` o `auth` (devuelve false): ante la duda, el comportamiento de siempre.
 */
export function useEstaSuplantando(): boolean {
  const enMemoria = useSelector((estado: any) => estado?.impersonation?.isImpersonating === true);
  const token = useSelector((estado: any) => estado?.auth?.token);
  return enMemoria || leerSuplantacionDelToken(token) !== null;
}

export default useEstaSuplantando;
